export default __webpack_public_path__ + "static/media/work-decor-2.7306a40b.svg";